import { IS_TAX_CDS_MODE } from './appMode'

export const DEFAULT_HOME_PAGE = {
  TRAFFIC_FINE_LOOKUP: 'TRAFFIC_FINE_LOOKUP',
  TAX_CDS_INTRODUCE: 'TAX_CDS_INTRODUCE'
}

export const getDefaultHomePage = () => {
  const raw = (process.env.REACT_APP_DEFAULT_HOME_PAGE || '').trim().toUpperCase()
  const allowed = new Set(Object.values(DEFAULT_HOME_PAGE))

  if (allowed.has(raw)) return raw

  return IS_TAX_CDS_MODE ? DEFAULT_HOME_PAGE.TAX_CDS_INTRODUCE : DEFAULT_HOME_PAGE.TRAFFIC_FINE_LOOKUP
}